// 📱 12/10/2026: o NAVEGADOR DE DENTRO DO INSTAGRAM E DO FACEBOOK (pedido do dono depois do teste
// dele). Lá dentro, colar o número do cartão falhou e a confirmação do banco é mais trabalhosa. No começo
// da assinatura, o site sugere abrir no Chrome (Android) ou no Safari (iPhone), sem obrigar: o Pix funciona
// bem lá dentro. As regras são as mesmas do aviso da StonelBox (10/10/2026, provado no Android): o
// "crachá" do navegador diz em que app a pessoa está; nada é guardado.
//
// CONTAGEM sem dado pessoal: o endereço aberto fora do app leva a marca `veio=instagram` (ou facebook).
// O registro do servidor do site (que já existe) mostra quantas pessoas chegaram com a marca; a tela
// tira a marca do endereço assim que a pessoa chega no Chrome ou no Safari.

export const MARCA = 'veio';
const APPS = ['instagram', 'facebook'];

export const appDoNavegador = ua => {
    const texto = `${ua ?? ''}`;
    if (/Instagram/i.test(texto)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(texto)) return 'facebook';
    return '';
};

// iPad novo se apresenta como "Macintosh", mas tem tela de toque
export const sistemaDoCelular = (ua, toques) => {
    const texto = `${ua ?? ''}`;
    if (/iPhone|iPad|iPod/.test(texto) || (/Macintosh/.test(texto) && toques > 1)) return 'iphone';
    if (/Android/i.test(texto)) return 'android';
    return '';
};

// Android: o "intent" pede ao celular para abrir o endereço no Chrome
export const enderecoNoChrome = (host, caminho) =>
    `intent://${host}${caminho}#Intent;scheme=https;package=com.android.chrome;end`;

// O endereço que abre FORA do app: a mesma página, a marca de onde veio e só o que é do site (o
// `provider` do cartão pré-pago e as etiquetas utm_ do anúncio). O fbclid e qualquer outra etiqueta que
// o Instagram ou o Facebook ponham ficam de fora, como na StonelBox.
const ETIQUETAS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
export const linkParaNavegador = (endereco, app) => {
    const atual = new URL(endereco);
    const novo = new URL(atual.pathname, atual.origin);
    const provider = atual.searchParams.get('provider') || '';
    if (/^[a-z0-9_-]{1,40}$/i.test(provider)) novo.searchParams.set('provider', provider);
    ETIQUETAS.forEach(nome => {
        const valor = atual.searchParams.get(nome) || '';
        if (/^[A-Za-z0-9_.-]{1,100}$/.test(valor)) novo.searchParams.set(nome, valor);
    });
    if (APPS.includes(app)) novo.searchParams.set(MARCA, app);
    return novo.toString();
};

// Quando a pessoa chega no Chrome ou no Safari com a marca: o endereço limpo (sem a marca) e o app de
// onde ela veio. Sem marca, ou ainda dentro do app, devolve null (não mexe em nada).
export const tirarMarcaDeVolta = (endereco, ua) => {
    const url = new URL(endereco);
    const app = url.searchParams.get(MARCA);
    if (!APPS.includes(app) || appDoNavegador(ua)) return null;
    url.searchParams.delete(MARCA);
    return { app, limpo: url.pathname + url.search + url.hash };
};

// O aviso aparece no COMEÇO da assinatura (pedido do dono, 12/10): logo depois de tocar em "Assinar", quando
// a pessoa ainda não digitou nada e não perde nada ao trocar de navegador.
// 💬 Tom de DICA (texto aprovado pelo dono, 12/10): falar só da vantagem do Chrome ou do Safari, nunca de
// "problema" ou "erro" (assusta na hora de pagar e parece defeito do site), e deixar claro que continuar no
// app também funciona.
// contexto: 'cadastro' (conta nova), 'conta' (quem já tem conta) ou 'colorir' (a folha de colorir, 22/10/2026:
// dentro do Instagram o PDF às vezes abre em branco ou não baixa; a dica fica embaixo do botão de baixar)
export const textosDoAviso = (so, app, contexto) => {
    const nav = so === 'iphone' ? 'Safari' : 'Chrome';
    const comum = {
        botao: 'Abrir no Chrome',
        barrado: 'Se não abriu sozinho, faça assim:',
        passo1: so === 'iphone' ? 'Toque nos três pontinhos (⋯), no canto de cima, à direita.'
            : 'Toque nos três pontinhos (⋮), no canto de cima da tela.',
        passo2: so === 'iphone' ? 'Toque em "Abrir no navegador externo" (ou "Abrir no Safari").'
            : 'Toque em "Abrir no Chrome".',
        copiar: 'Copiar o link',
        copiado: `Link copiado. Cole no ${nav}.`,
        naoCopiou: 'Não deu para copiar sozinho. Segure o dedo no link abaixo e copie.',
        continuar: 'Continuar aqui mesmo'
    };
    if (contexto === 'colorir') return {
        ...comum,
        titulo: `Dica: baixe pelo ${nav}`,
        texto: `No ${nav}, fica mais fácil baixar e imprimir a folha.`,
        depois: `No ${nav}, é só tocar de novo em "Baixar a folha (PDF)".`,
        pix: 'Prefere ficar aqui? Pode tocar no botão normalmente.',
    };
    return {
        ...comum,
        titulo: `Dica: assine pelo ${nav}`,
        texto: `Se for pagar com cartão, no ${nav} fica mais fácil colar o número e confirmar a compra no app do banco.`,
        depois: contexto === 'conta'
            ? `No ${nav}, você entra com o seu e-mail e a sua senha e escolhe o plano.`
            : 'Você começa o cadastro do zero, sem perder nada.',
        pix: 'Prefere ficar aqui? Pode continuar normalmente, com cartão ou Pix.',
    };
};
